import { type DateFormat, type TimeFormat } from '@ledium/types';

import { useGlobalStore } from '../store/globalStore/context/globalContext';
import { formatDate, formatTime } from '../utils/dateTimeFormatters';

const useDateTimeFormatters = () => {
    const {
        globalState: { dateFormat, timeFormat }
    } = useGlobalStore();

    const resolvedDateFormat: DateFormat = dateFormat ?? 'YYYY-MM-DD';
    const resolvedTimeFormat: TimeFormat = timeFormat ?? '24';

    return {
        formatDate: (value: number | string) => formatDate(value, resolvedDateFormat),
        formatTime: (value: string) => formatTime(value, resolvedTimeFormat)
    };
};

export default useDateTimeFormatters;
